import { Injectable } from '@angular/core'
import { AbstractControl, UntypedFormArray } from '@angular/forms'
import { Observable, of } from 'rxjs'
import { map, startWith } from 'rxjs/operators'

export interface RuleCount {
  total: number
  inner: number
}

@Injectable({
  providedIn: 'root',
})
export class RuleCountService {
  calculateRuleCount(value: any[]): RuleCount {
    if (!value || !Array.isArray(value)) {
      return { total: 0, inner: 0 }
    }

    // Simply count the array length to match the number of form rows
    const totalRules = value.length

    // Count inner rules for AND groups
    let innerRules = 0
    value.forEach((rule: any) => {
      if (rule && rule.type === 'all' && rule.rules && Array.isArray(rule.rules)) {
        innerRules += rule.rules.length
      }
    })

    return { total: totalRules, inner: innerRules }
  }

  getRuleCount$(formControl: AbstractControl): Observable<RuleCount> {
    if (!formControl) {
      return of({ total: 0, inner: 0 })
    }

    return formControl.valueChanges.pipe(
      startWith(formControl.value),
      map((value) => this.calculateRuleCount(value))
    )
  }
}
